import script from "./Error.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error.vue?vue&type=script&setup=true&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=edd3f2f0&lang=scss"

const __exports__ = script;

export default __exports__